<template>
  <modal
    :active="true"
    class="dispute-creation-confirmation"
    size="medium"
    tertiary-button-label="Cancel"
    :primary-button-label="buttonName"
    @onClose="onClose()"
    @onConfirm="onConfirm()">
    <template #header>
      <p>Alert!</p>
    </template>
    <template #content>
      <div class="dispute-creation-confirmation__container">
        Invoice amount for selected invoice no
        {{ rowData["invoiceNumber"] }} is negative. Are you sure you want to
        {{ buttonName }} for this?
      </div>
    </template>
  </modal>
</template>

<script>
export default {
  name: "DisputeCreationConfirmationModal",
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    buttonName: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    onConfirm() {
      this.$emit("onModalClose");
      this.$emit("updateInvoice", this.rowData);
    },
  },
};
</script>

<style lang="scss">
.dispute-creation-confirmation {
  .modal--medium {
    height: fit-content;
    width: 800px;
  }
  &__container {
    padding: 0px 16px;
  }
}
</style>
